import convertBase64ToBlob from 'Helper/convertBase64ToBlob';

const postEndStreamRequest = async (data) => {
  const selfieImage = await convertBase64ToBlob(data?.selfieImage);
  const locationImage = await convertBase64ToBlob(data?.locationImage);
  
  const formData = new FormData();

  formData.append('type', 'STOP');
  formData.append('selfieImage', selfieImage);
  formData.append('locationImage', locationImage);
  formData.append('note', data?.note || '');

  return formData;
};

export default postEndStreamRequest;
